export default {
	props: {
		color: {
			type: String
		}
	},

	computed: {
		style() {
			return {
				color: this.color
			};
		}
	}
};
